import React, { useState } from "react";
import Button from "../../components/ui/Button";
import { Plus } from "lucide-react";

const SourcingSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const features = [
    {
      id: "01",
      title: "Cold Chain Excellence",
      content:
        "Ensuring temperature-sensitive materials remain stable throughout the entire supply chain process.",
    },
    {
      id: "02",
      title: "Complete Documentation",
      content:
        "Comprehensive regulatory and compliance paperwork handled by our expert logistics team.",
    },
    {
      id: "03",
      title: "Import/Export Support",
      content:
        "Navigating international customs and global trade regulations to ensure seamless delivery.",
    },
  ];

  return (
    <section className="bg-white py-8 md:py-16 px-6 md:px-12 lg:px-24 font-sans">
      <div className="max-w-[1800px] mx-auto flex  justify-between items-start gap-[30px] flex-wrap md:flex-nowrap">
        {/* Left Content */}
        <div className="space-y-6">
          <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] leading-tight">
            We Handle the <br /> Complex Details
          </h2>
          <p className="text-[18px] md:text-[20px] xl:text-[24px] text-lg max-w-md">
            Flexible sourcing strategies tailored to your timeline and
            scientific goals.
          </p>
          <Button
            className="px-8 py-2 border-2 border-[#183076] text-[#183076] text-[18px] xl:text-[24px] font-semibold rounded-full hover:bg-[#183076] hover:text-white transition-colors duration-300"
            text="Lorem Ipsum"
          />
        </div>

        {/* Right Accordion List */}
        <div className="divide-y divide-[#183076] max-w-[1041px]">
          {features.map((feature, index) => (
            <div key={feature.id} className="py-6">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between group text-left"
              >
                <div className="flex items-center space-x-6">
                  <span className="text-gray-300 text-[20px] md:text-[24px] xl:text-[30px] font-bold">
                    {feature.id}
                  </span>
                  <span className="text-[#183076] text-[20px] md:text-[24px] xl:text-[30px] font-bold  transition-colors">
                    {feature.title}
                  </span>
                </div>
                <Plus
                  className={`text-[#183076] transition-transform duration-300 ${
                    openIndex === index ? "rotate-45" : "rotate-0"
                  }`}
                  size={24}
                />
              </button>

              {/* Expandable Content */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index
                    ? "max-h-40 opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="pl-16 text-[18px] md:text-[20px] xl:text-[24px]">
                  {feature.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SourcingSection;
